import React from 'react';
import { IncorporadoraForm } from './IncorporadoraForm';

export const NovaIncorporadora: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <IncorporadoraForm />
    </div>
  );
};
